import * as React from 'react';
export const IcMotionOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11 6.13l-.39.24 2.76 2.76A12.81 12.81 0 0018 10a1 1 0 100-2 10.31 10.31 0 01-5.88-1.78A1 1 0 0011 6.13zM11.5 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm9.21 14.29l-16-16a1.004 1.004 0 00-1.42 1.42l4.13 4.13a15.171 15.171 0 00-2.25 2.61 1 1 0 00.28 1.38A.94.94 0 006 13a1 1 0 00.83-.45 13.538 13.538 0 012-2.3l1.66 1.66v1c-.47 3.53-5.08 7.26-5.12 7.3a1 1 0 00-.16 1.4A1 1 0 006 22a1 1 0 00.62-.22c.19-.15 3.88-3.14 5.33-6.71 1.37 1.65 3.49 4.4 4.1 6.25A1 1 0 0017 22c.108-.003.216-.02.32-.05a1 1 0 00.68-1.27A13.994 13.994 0 0016.6 18l2.69 2.7a1.001 1.001 0 101.42-1.41z'
      fill='currentColor'
    />
  </svg>
);
